<template>
	<div class="mt-4">
		<h3>Adresse(s) d'envoi (facturation)</h3>
		<template
			v-if="senderAddresses && senderAddresses.length > 0"
			v-for="(address, i) in senderAddresses">
			<CRow>
				<CCol sm="12">
					<h5>Adresse n°{{ i }}</h5>
					<CCard class="mt-3" :key="i">
						<CCardHeader
							class="collapse-card-header"
							@click="toogleCollapse('collapse' + address.id)">
							<span>
								{{
									`${address.address}, ${address.postalCode} ${address.city}, ${getCountry(
										address.country
									)}`
								}}</span
							>
							<span class="float-right">
								<CIcon
									:class="{
										'collapse-icon': true,
										'collapse-opened': collapses['collapse' + address.id],
									}"
									name="cil-chevron-bottom" />
							</span>
						</CCardHeader>

						<CCollapse :show="collapses['collapse' + address.id]">
							<form
								class="mt-3"
								:ref="address['@id']"
								:action="address['@id']"
								method="post"
								axiosMethod="patch">
								<CCardBody class="m-3">
									<CRow>
										<CCol sm="6">
											<CInput
												type="text"
												label="Nom"
												name="lastName"
												:value="address.lastName" />
										</CCol>
										<CCol sm="6">
											<CInput
												type="text"
												label="Prénom"
												name="firstName"
												:value="address.firstName" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<CInput
												type="text"
												label="Dénomination sociale"
												name="companyName"
												:value="address.companyName" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<CInput
												type="text"
												label="Adresse"
												name="address"
												:value="address.address" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<CInput
												type="text"
												label="Complément d'adresse"
												name="address2"
												:value="address.address2" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="4">
											<CInput
												type="text"
												label="Ville"
												name="city"
												:value="address.city" />
										</CCol>
										<CCol sm="4">
											<CInput
												type="text"
												label="Code postal"
												name="postalCode"
												:value="address.postalCode" />
										</CCol>
										<CCol sm="4">
											<div class="form-group">
												<label>Pays</label>
												<GTreeView
													input-name="country"
													fetch-url="/api/countries?itemsPerPage=246"
													:multiple="false"
													placeholder="Choisissez un pays..."
													:value="address.country" />
											</div>
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<GInputPhoneNumber
												class="phone-input-container"
												:value="address.phone"
												inputName="phone"
												label="Téléphone" />
										</CCol>
									</CRow>
									<CRow alignHorizontal="end">
										<CCol class="d-flex justify-content-end mt-3" sm="12">
											<CButton
												class="text-right"
												color="success"
												v-on:click="onSubmit($refs[address['@id']])"
												>Sauvegarder</CButton
											>
										</CCol>
									</CRow>
								</CCardBody>
							</form>
						</CCollapse>
					</CCard>
				</CCol>
			</CRow>
		</template>

		<template v-else>
			<h5 class="text-danger">Aucune adresse d'envoi renseignée</h5>
			<CButton color="primary" @click="openAddModal('sender')">Ajouter une adresse d'envoi</CButton>
		</template>

		<hr />

		<template v-if="receiverAddresses && receiverAddresses.length > 0">
			<CRow alignHorizontal="between" class="px-3 mb-4">
				<h3>Adresse(s) de réception</h3>
				<CButton color="primary" @click="openAddModal('receiver')"
					>Ajouter une adresse de récéption</CButton
				>
			</CRow>
		</template>

		<template v-else>
			<h5 class="text-danger">Aucune adresse de récéption renseignée</h5>
			<CButton color="primary" @click="openAddModal('receiver')"
				>Ajouter une adresse de récéption</CButton
			>
		</template>

		<template v-if="receiverAddresses" v-for="(address, i) in receiverAddresses">
			<CRow v-if="address.type === 'receiver'">
				<CCol sm="12">
					<h5>Adresse n°{{ i }}</h5>
					<CCard class="mt-3" :key="i">
						<CCardHeader
							class="collapse-card-header"
							@click="toogleCollapse('collapse' + address.id)">
							<span>
								{{
									`${address.address}, ${address.postalCode} ${address.city}, ${getCountry(
										address.country
									)}`
								}}</span
							>
							<span class="float-right">
								<CIcon
									:class="{
										'collapse-icon': true,
										'collapse-opened': collapses['collapse' + address.id],
									}"
									name="cil-chevron-bottom" />
							</span>
						</CCardHeader>

						<CCollapse :show="collapses['collapse' + address.id]">
							<form
								class="mt-3"
								:ref="address['@id']"
								:action="address['@id']"
								method="post"
								axiosMethod="patch">
								<CCardBody class="m-3">
									<CRow>
										<CCol sm="6">
											<CInput
												type="text"
												label="Nom"
												name="lastName"
												:value="address.lastName" />
										</CCol>
										<CCol sm="6">
											<CInput
												type="text"
												label="Prénom"
												name="firstName"
												:value="address.firstName" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<CInput
												type="text"
												label="Dénomination sociale"
												name="companyName"
												:value="address.companyName" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<CInput
												type="text"
												label="Adresse"
												name="address"
												:value="address.address" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<CInput
												type="text"
												label="Complément d'adresse"
												name="address2"
												:value="address.address2" />
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="4">
											<CInput
												type="text"
												label="Ville"
												name="city"
												:value="address.city" />
										</CCol>
										<CCol sm="4">
											<CInput
												type="text"
												label="Code postal"
												name="postalCode"
												:value="address.postalCode" />
										</CCol>
										<CCol sm="4">
											<div class="form-group">
												<label>Pays</label>
												<GTreeView
													input-name="country"
													fetch-url="/api/countries?itemsPerPage=246"
													:multiple="false"
													placeholder="Choisissez un pays..."
													:value="address.country" />
											</div>
										</CCol>
									</CRow>
									<CRow>
										<CCol sm="12">
											<GInputPhoneNumber
												class="phone-input-container"
												:value="address.phone"
												inputName="phone"
												label="Téléphone" />
										</CCol>
									</CRow>
									<CRow alignHorizontal="end">
										<CCol class="d-flex justify-content-end mt-3" sm="12">
											<CButton
												class="text-right"
												color="success"
												v-on:click="onSubmit($refs[address['@id']])"
												>Sauvegarder</CButton
											>
										</CCol>
									</CRow>
								</CCardBody>
							</form>
						</CCollapse>
					</CCard>
				</CCol>
			</CRow>
		</template>
		<AddAddressModal
			ref="addModal"
			:user="user"
			:countries-options="countriesOptions"
			v-on:refresh:user="$emit('refresh:user')" />
	</div>
</template>

<script>
	import AddAddressModal from '../../../../components/modals/AddAddressModal';
	import GTreeView from '../../../../components/ghostlexly-components/GTreeView';
	import GInputPhoneNumber from '../../../../components/ghostlexly-components/GInputs/GInputPhoneNumber';
	import { filter } from 'lodash';

	export default {
		components: { GInputPhoneNumber, AddAddressModal, GTreeView },
		props: {
			user: Object,
		},
		watch: {
			user: {
				immediate: true,
				handler: function (newVal) {
					if (newVal.addresses) {
						newVal.addresses.forEach((address, i) => {
							this.$set(this.collapses, 'collapse' + address.id, false);
						});
					}

					this.senderAddresses = filter(newVal.addresses, { type: 'sender' });
					this.receiverAddresses = filter(newVal.addresses, { type: 'receiver' });
				},
			},
		},
		data() {
			return {
				roleMapping: {
					ROLE_CUSTOMER: 'Client',
					ROLE_GUEST: 'Invité',
					ROLE_ADMIN: 'Administrateur',
				},
				collapses: {},
				countries: [],
				countriesOptions: [],
				receiverAddresses: [],
				senderAddresses: [],
			};
		},
		methods: {
			openAddModal(type) {
				this.$refs.addModal.prefix = type === 'sender' ? 'address.' : 'addresses[0].';
				this.$refs.addModal.showModal = true;
				this.$refs.addModal.type = type;
			},
			toogleCollapse(i) {
				this.collapses[i] = !this.collapses[i];
			},
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Adresse modifiée avec succès !');
						this.$emit('update:addresses', res.data);
					} else {
						this.$toast.error(res.data['hydra:description']);
					}
				});
			},
			getCountry(iri) {
				const country = this.countriesOptions.find(country => country.value === iri);

				return country ? country.label : '';
			},
			loadCountries() {
				this.$axios
					.get('/api/countries?itemsPerPage=246')
					.then(res => {
						this.countries = res.data['hydra:member'];
						this.countriesOptions = res.data['hydra:member'].map(country => {
							return {
								value: country['@id'],
								label: country.name,
							};
						});
					})
					.catch(err => {
						this.$toast.error(
							'Erreur lors du chargement des pays, veuillez contacter un administrateur'
						);
					});
			},
		},
		mounted() {
			this.loadCountries();
		},
	};
</script>

<style>
	.collapse-card-header {
		cursor: pointer;
	}

	.collapse-icon {
		transition: transform 0.3s ease;
	}

	.collapse-opened {
		transform: rotateX(-180deg);
	}
</style>
